import { createContext, useContext, useEffect, useState } from 'react';
import { io } from 'socket.io-client';
import { useAuthSafe } from '@arc/frontend/util-auth';
const WebsocketClientContext = createContext(null);
export function WebsocketProvider({
  children
}) {
  const {
    user
  } = useAuthSafe();
  const [wsClient, setWSClient] = useState(null);
  useEffect(() => {
    const client = io({
      transports: ['websocket'],
      reconnectionDelayMax: 10_000
    });
    setWSClient(client);
    return () => {
      client.disconnect();
      setWSClient(null);
    };
  }, [user]);
  return <WebsocketClientContext.Provider value={wsClient}>
			{children}
		</WebsocketClientContext.Provider>;
}

/**
 * Get the websocket client. If you want to listen to events use
 * `useWebsocketListener` instead.
 */
export const useWebsockets = () => useContext(WebsocketClientContext);